import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CalendarIcon, InformationCircleIcon, ExclamationTriangleIcon, ChartBarIcon } from '@heroicons/react/24/outline';

function ViewsNavigation() {
  const location = useLocation();
  
  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(`${path}`);
  };
  
  return (
    <div className="border-b border-gray-700 mb-6">
      <nav className="-mb-px flex space-x-6">
        <Link
          to="/views/due-date-calendar"
          className={`${
            isActive('/views/due-date-calendar')
              ? 'border-indigo-500 text-indigo-400'
              : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-600'
          } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center`}
        >
          <CalendarIcon className="mr-2 h-5 w-5" />
          Accountable Due Dates
        </Link>
        
        <Link
          to="/views/informed-projects"
          className={`${
            isActive('/views/informed-projects')
              ? 'border-indigo-500 text-indigo-400'
              : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-600'
          } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center`}
        >
          <InformationCircleIcon className="mr-2 h-5 w-5" />
          Informed Projects
        </Link>

        <Link
          to="/views/missing-information"
          className={`${
            isActive('/views/missing-information')
              ? 'border-indigo-500 text-indigo-400'
              : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-600'
          } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center`}
        >
          <ExclamationTriangleIcon className="mr-2 h-5 w-5" />
          Missing Information
        </Link>
        
        <Link
          to="/views/workload-report"
          className={`${
            isActive('/views/workload-report')
              ? 'border-indigo-500 text-indigo-400'
              : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-600'
          } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center`}
        >
          <ChartBarIcon className="mr-2 h-5 w-5" />
          Team Workload
        </Link>
      </nav>
    </div>
  );
}

export default ViewsNavigation; 